// src/utils/markdown.js
// Renderizador Markdown mínimo y SEGURO: escapa el HTML de entrada antes de
// aplicar el formato, por lo que el contenido del LLM no puede inyectar HTML.
// Soporta: encabezados, negrita, cursiva, código en línea y bloques, listas
// (viñetas y numeradas), citas, separadores, enlaces http(s) y párrafos.

function escapeHtml(t) {
  return String(t)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function inline(t) {
  return escapeHtml(t)
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*])\*([^*\n]+)\*/g, "$1<em>$2</em>")
    .replace(/`([^`]+)`/g, "<code>$1</code>")
    .replace(
      /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );
}

export function renderMarkdown(src) {
  if (!src) return "";
  const lines = String(src).replace(/\r\n/g, "\n").split("\n");
  let html = "";
  let listType = null; // 'ul' | 'ol' | null
  let inCode = false;
  let codeBuf = "";

  const closeList = () => {
    if (listType) {
      html += "</" + listType + ">";
      listType = null;
    }
  };

  for (const raw of lines) {
    const t = raw.trim();

    // Bloques de código ```
    if (/^```/.test(t)) {
      if (inCode) {
        html += '<pre class="md-pre"><code>' + escapeHtml(codeBuf) + "</code></pre>";
        inCode = false;
        codeBuf = "";
      } else {
        closeList();
        inCode = true;
        codeBuf = "";
      }
      continue;
    }
    if (inCode) {
      codeBuf += (codeBuf ? "\n" : "") + raw;
      continue;
    }

    if (!t) {
      closeList();
      continue;
    }

    let m;
    if ((m = t.match(/^(#{1,6})\s+(.*)$/))) {
      closeList();
      const lvl = m[1].length;
      html += "<h" + lvl + ">" + inline(m[2]) + "</h" + lvl + ">";
      continue;
    }
    if ((m = t.match(/^[-*]\s+(.*)$/))) {
      if (listType !== "ul") {
        closeList();
        html += "<ul>";
        listType = "ul";
      }
      html += "<li>" + inline(m[1]) + "</li>";
      continue;
    }
    if ((m = t.match(/^\d+\.\s+(.*)$/))) {
      if (listType !== "ol") {
        closeList();
        html += "<ol>";
        listType = "ol";
      }
      html += "<li>" + inline(m[1]) + "</li>";
      continue;
    }
    if ((m = t.match(/^>\s+(.*)$/))) {
      closeList();
      html += "<blockquote>" + inline(m[1]) + "</blockquote>";
      continue;
    }
    if (/^([-*_])\1{2,}$/.test(t)) {
      closeList();
      html += "<hr/>";
      continue;
    }

    closeList();
    html += "<p>" + inline(t) + "</p>";
  }

  if (inCode) {
    html += '<pre class="md-pre"><code>' + escapeHtml(codeBuf) + "</code></pre>";
  }
  closeList();
  return html;
}

export default renderMarkdown;
